import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  input: {
    display: 'flex',
    height: theme.spacing(5.25),
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.modal.default,
    padding: theme.spacing(1.25),

    '& input': {
      textAlign: 'center',
    },

    '& fieldset': {
      display: 'none',
    },

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },

  active: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },

  disabled: {
    pointerEvents: 'none',
    cursor: 'default',
    opacity: '0.8',
  },
}));
